import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import cn from 'classnames'
import { menShoes, womenShoes } from './content'
import Radio from '../../UI/Input/Radio'
import { getAuthProfile } from '../../api/getApi'

const TableSizes = ({
  handleShoeSizeClick,
  handleSuitSizeClick,
  className,
  suitSizes = [],
  selectedFootSize,
  selectedSuitSizeId,
}) => {
  const [activeTab, setActiveTab] = useState(null)
  const [loading, setLoading] = useState(false)

  const normalizedFootSize = selectedFootSize === null || selectedFootSize === undefined ? null : `${selectedFootSize}`
  const normalizedSuitSizeId =
    selectedSuitSizeId === null || selectedSuitSizeId === undefined ? null : `${selectedSuitSizeId}`

  useEffect(() => {
    setLoading(true)
    getAuthProfile()
      .then((data) => {
        setActiveTab(data.gender.name)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div className={className}>
      <div className={styles.table}>
        <p className={styles.warning}>Click to fill in the data</p>

        <div className={styles.header}>
          <div className={styles.headerTitle}>Clothes & Shoes</div>
          <div className={cn(styles.sex_container, { [styles.sex_container_loading]: loading })}>
            <label>
              <Radio
                onChange={() => setActiveTab('Female')}
                name='gender'
                isChecked={activeTab === 'Female'}
                label='Female'
                className={cn(styles.sexRadio, {
                  [styles.sexRadioActive]: activeTab === 'Female',
                })}
              />
            </label>

            <label>
              <Radio
                onChange={() => setActiveTab('Male')}
                name='gender'
                isChecked={activeTab === 'Male' || activeTab === 'Other'}
                label='Male'
                className={cn(styles.sexRadio, {
                  [styles.sexRadioActive]: activeTab === 'Male',
                })}
              />
            </label>
          </div>
        </div>
        <div className={styles.container}>
          {activeTab !== null && activeTab === 'Male' ? (
            <div className={styles.tables}>
              <div className={styles.table_scroll}>
                <table>
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Chest (CM)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {suitSizes.map((item, index) => (
                      <tr
                        onClick={() => handleSuitSizeClick(item.name, item.id)}
                        key={index}
                        className={cn({ [styles.row_active]: normalizedSuitSizeId === `${item.id}` })}
                      >
                        <td>{item.name}</td>
                        <td>{item.male_data}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={styles.table_scroll}>
                <table>
                  <thead>
                    <tr>
                      <th>UK</th>
                      <th>EU</th>
                      <th>US</th>
                      <th>AU</th>
                      <th>CM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {menShoes.map((item, index) => (
                      <tr
                        onClick={() => handleShoeSizeClick(item.eu)}
                        key={index}
                        className={cn({ [styles.row_active]: normalizedFootSize === `${item.eu}` })}
                      >
                        <td>{item.uk}</td>
                        <td className={cn({ [styles.cell_active]: normalizedFootSize === `${item.eu}` })}>{item.eu}</td>
                        <td>{item.us}</td>
                        <td>{item.au}</td>
                        <td>{item.cm}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className={styles.tables}>
              <div className={styles.table_scroll}>
                <table>
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Chest (CM)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {suitSizes.map((item, index) => (
                      <tr
                        onClick={() => handleSuitSizeClick(item.name, item.id)}
                        key={index}
                        className={cn({ [styles.row_active]: normalizedSuitSizeId === `${item.id}` })}
                      >
                        <td>{item.name}</td>
                        <td>{item.female_data}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={styles.table_scroll}>
                <table>
                  <thead>
                    <tr>
                      <th>UK</th>
                      <th>EU</th>
                      <th>US</th>
                      <th>AU</th>
                      <th>CM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {womenShoes.map((item, index) => (
                      <tr
                        onClick={() => handleShoeSizeClick(item.eu)}
                        key={index}
                        className={cn({ [styles.row_active]: normalizedFootSize === `${item.eu}` })}
                      >
                        <td>{item.uk}</td>
                        <td className={cn({ [styles.cell_active]: normalizedFootSize === `${item.eu}` })}>{item.eu}</td>
                        <td>{item.us}</td>
                        <td>{item.au}</td>
                        <td>{item.cm}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <p className={styles.warning}>
          The size ratio table is for informational purposes only. It is necessary to specify the sizes of clothes and
          shoes, depending on the manufacturer.
        </p>
      </div>
    </div>
  )
}

export default TableSizes
